
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import type { Klass, LexicalNode } from "lexical";

const Nodes: Array<Klass<LexicalNode>> = [
	ListNode,
	ListItemNode,
	AutoLinkNode,
	LinkNode,
];

export default Nodes;
